export enum ConveyorDirection {
  LEFT = 'Left',
  RIGHT = 'Right',
  FRONT = 'Front',
}
